import PasswordInput from '../../PasswordInput';
import { AuthField, AuthLabel } from '../../authModal.styles';

const AuthLoginPasswordField = ({
	password,
	onPasswordChange,
	isAuthPending,
	isAuthSuccess,
	translations,
}) => (
	<AuthField>
		<AuthLabel htmlFor="auth-password">
			{translations.passwordLabel || 'Password'}
		</AuthLabel>
		<PasswordInput
			id="auth-password"
			placeholder={translations.passwordPlaceholder || 'enter your password'}
			value={password}
			onChange={(event) => onPasswordChange(event.target.value)}
			disabled={isAuthPending || isAuthSuccess}
			showPasswordLabel={translations.showPassword}
			hidePasswordLabel={translations.hidePassword}
			autoComplete="current-password"
		/>
	</AuthField>
);

export default AuthLoginPasswordField;
